import React, { useState } from "react";
import { Brand } from "../../../../_metronic/layout/components/brand/Brand";
import { AdminIcon } from "../../../util/Icons";
import { ReportsModal } from "../modals/reports/ReportsModal";
import { BreadCrumbs } from "./BreadCrumbs";
import { Dropdown } from "./Dropdown";
import { UserMenu } from "./UserMenu";

export const Header = () => {
    let [isOpen, setIsOpen] = useState(false)

    return (
        <div
            className="d-flex w-100 border-bottom font-weight-bold align-items-center"
            style={{
                padding: "14px 19px",
                height: "52px"
            }}
        >
            <Brand />
            <div className="d-flex justify-content-center w-100 align-items-center">
                <BreadCrumbs />
            </div>
            <Dropdown toggleOnHover>
                <Dropdown.Button>
                    <AdminIcon size={"24px"} />
                </Dropdown.Button>
                <Dropdown.Menu anchorRight>
                    <UserMenu showReports={() => setIsOpen(true)}/>
                </Dropdown.Menu>
            </Dropdown>

            <ReportsModal showReportsModal={isOpen} onHide={() => setIsOpen(false)}/>
        </div>
    )
}